import { __awaiter, __decorate } from "tslib";
import CatalogItem from '@slickdeals/durango/dist/javascript/core/catalogItem';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { catalogItem } from '@slickdeals/durango/dist/javascript/decorators/catalogItem';
import Collapsible, { ClassNames as CollapsibleClassNames, } from '@slickdeals/blueprint-twig/javascript/components/collapsible';
import IconStrategy from '@slickdeals/blueprint-twig/javascript/strategies/indicator/iconStrategy';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { Animations } from '@slickdeals/blueprint-twig/javascript/utilities/animation';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import { name as heapName } from '../heap/heap';
import '../../scss/patterns/cashbackFAQ.scss';
export const name = 'CashbackFAQ';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-cashbackFAQ";
    ClassNames["CollapsibleIndicator"] = "js-collapsibleIndicator";
})(ClassNames || (ClassNames = {}));
export const dependencies = Object.assign({}, Injector.createDependency(heapName, InjectorScope.Singleton));
let CashbackFAQ = class CashbackFAQ extends CatalogItem {
    constructor(heap, options) {
        super(options);
        this.heap = heap;
        this.options = options;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.init.call(this);
            this.element = yield CatalogItem.loadElement(name, this.options);
            this.initializeCollapsibles();
            this.trackImpression();
        });
    }
    initializeCollapsibles() {
        // Get collapsible ids for all collapsible sections that exist in this element
        const collapsibleSections = Array.from(this.element.querySelectorAll(`.${CollapsibleClassNames.JavaScript}`));
        collapsibleSections.forEach(collapsible => {
            // Gets the collapsible id
            const collapsibleId = collapsible.id;
            // Gets the indicator container within the collapsible
            const indicatorContainer = collapsible.querySelector(`.${ClassNames.CollapsibleIndicator}`);
            // Creates the indicator to be used by visibility toggle
            const indicatorStrategy = new IconStrategy({
                element: indicatorContainer,
                inactiveIconName: 'bbCarrotArrowDown',
                animation: Animations.Flip,
                defaultState: false,
            });
            // Sets the options for collapsible
            const collapsibleOptions = {
                id: collapsibleId,
                indicatorStrategy,
                expanded: false,
            };
            // Creates a new TS instance for collapsibleInstance
            new Collapsible(collapsibleOptions);
        });
    }
    trackImpression() {
        this.heap.track('Rewards For All - Cashback FAQ Section - Impression')
            .catch(err => Logger.warn(`Failed to track ${name} Impression: ${err}`));
    }
};
CashbackFAQ = __decorate([
    injectable(name, dependencies),
    catalogItem(name)
], CashbackFAQ);
export default CashbackFAQ;
